import { InvoicingCutoffModel } from './../invoicing/invoicing-cutoff.model';
import { RentalPeriodModel } from './rental-period.model';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { SuspensionStateEnums } from 'src/app/enum/suspension-state-enum';

export class SuspensionModel {
  suspensionId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  days: number | null = null;
  costCenterId: number = 0;
  costCenter: CostCenterModel = new CostCenterModel();
  dateSuspension: Date = new Date;
  rentalPeriodId: number = 0;
  rentalPeriod: RentalPeriodModel = new RentalPeriodModel();
  suspensionStateId: number = SuspensionStateEnums.open;
  swBlock: boolean = false;
  invoicingCutoffId: number | null = null;
  invoicingCutoff: InvoicingCutoffModel | null = null;
  maintenanceOrderId: number | null = null;
  observation: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}